<template>
  <div>
    <div class="top-fade-in row">
      <input-field
        label="Instance ID"
        label-position="top"
        class="px-1 col-12 col-sm-6"
      >
        <a
          v-clipboard:copy="host.instanceId"
          v-clipboard:success="copySuccess"
        >
          {{ host.instanceId || '-' }}
          <GjIcon
            name="Copy"
            size="17"
          />
        </a>
      </input-field>
      <input-field
        label="Host Name"
        label-position="top"
        class="px-1 col-12 col-sm-6"
      >
        {{ host.hostname || '-' }}
      </input-field>
      <input-field
        label="Kernel Name"
        label-position="top"
        class="px-1 col-12 col-sm-6"
      >
        {{ host.kernelName || '-' }}
      </input-field>
      <input-field
        label="Kernel Version"
        label-position="top"
        class="px-1 col-12 col-sm-6"
      >
        {{ host.kernelVersion || '-' }}
      </input-field>
    </div>
    <paper class="card-info mt-2">
      <template v-slot:title>
        <p class="mb-0">
          Bios
        </p>
      </template>
      <div class="w-100">
        <div class="row">
          <input-field
            label="Bios Name"
            label-position="top"
            class="px-1 col-12 col-sm-6"
          >
            {{ host.biosName || '-' }}
          </input-field>
          <input-field
            label="Bios Caption"
            label-position="top"
            class="px-1 col-12 col-sm-6"
          >
            {{ host.biosCaption || '-' }}
          </input-field>
          <input-field
            label="Bios Description"
            label-position="top"
            class="px-1 col-12 col-sm-6"
          >
            {{ host.biosDescription || '-' }}
          </input-field>
          <input-field
            label="Bios Version"
            label-position="top"
            class="px-1 col-12 col-sm-6"
          >
            <a
              v-clipboard:copy="host.biosVersion"
              v-clipboard:success="copySuccess"
            >
              {{ host.biosVersion || '-' }}
              <GjIcon
                name="Copy"
                size="17"
              />
            </a>
          </input-field>
        </div>
      </div>
    </paper>
    <cpu-info :host="host" />
    <memory-info :capacity="host.memoryCapacity || 0" />
  </div>
</template>
<script>
import Paper from '@/components/paper/Paper.vue'
import MemoryInfo from './info/MemoryInfo.vue'
import CpuInfo from './info/CpuInfo.vue'

export default {
  name: 'HostDetailsOverview',
  components: { Paper, MemoryInfo, CpuInfo },
  props: {
    host: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.card-info::v-deep {
  .card-header {
    padding: 16px 0;
  }
  .card-body {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 14px;
  }
}
</style>
